import { useActiveSkills } from '@/services/tasks/useSkills';
import { useGetEmployeeSkillsQuery } from '../../../services/gql/graphql.generated';
import { EmployeeSkills } from '../../../types/employeeForShift.types';
import { employeeSkills } from '@/services/gql/skills.gql';

export const useEmployeesSkillsList = (employeeIds: string[]) => {
  const activeSkills = useActiveSkills();
  const activeSkillIds = activeSkills.map(s => s.id);
  const [{ data: skillsData }] = useGetEmployeeSkillsQuery({ variables: { employeeIds: employeeIds } });

  if (!skillsData?.employeeSkillsByEmployeeIds) {
    return [];
  }

  const employeesSkillsList: EmployeeSkills[] = skillsData.employeeSkillsByEmployeeIds.map(emp => {
    const retObject: EmployeeSkills = {
      employeeId: emp.employeeId,
      skills: []
    };

    if (emp.skills) {
      retObject.skills = emp.skills
        .filter(s => activeSkillIds.includes(s.skillId))
        .map(readSkill => {
          const skill = activeSkills.find(s => s.id === readSkill.skillId);

          return { name: skill?.displayName || readSkill.name, skillId: readSkill.skillId };
        });
    }

    return retObject;
  });

  return employeesSkillsList;
};
